// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise'
import { OpenAPI } from './core/OpenAPI'
import { request as __request } from './core/request'
import type {
  AdminCompaniesControllerGetCompaniesResponse,
  AdminStatsControllerGetAgeStatsData,
  AdminStatsControllerGetAgeStatsResponse,
  AdminStatsControllerGetGenderStatsData,
  AdminStatsControllerGetGenderStatsResponse,
  AdminStatsControllerGetIncomeStatsData,
  AdminStatsControllerGetIncomeStatsResponse,
  AdminStatsControllerGetRaceStatsData,
  AdminStatsControllerGetRaceStatsResponse,
  AdminStatsControllerGetTopicsStatsData,
  AdminStatsControllerGetTopicsStatsResponse,
  AdminStatsControllerGetUserStatsData,
  AdminStatsControllerGetUserStatsResponse,
  AdminUsersControllerVerifyUserData,
  AdminUsersControllerVerifyUserResponse,
  AdminWhitelistControllerAddWhitelistedEmailsData,
  AdminWhitelistControllerAddWhitelistedEmailsResponse,
  AdminWhitelistControllerDeleteWhitelistedEmailsData,
  AdminWhitelistControllerDeleteWhitelistedEmailsResponse,
  AdvisorAppointmentsControllerGetAllAppointmentsData,
  AdvisorAppointmentsControllerGetAllAppointmentsResponse,
  AdvisorControllerGetAllAdvisorsData,
  AdvisorControllerGetAllAdvisorsResponse,
  AdvisorControllerGrantAccessData,
  AdvisorControllerGrantAccessResponse,
  AdvisorControllerRevokeAccessData,
  AdvisorControllerRevokeAccessResponse,
  AdvisorGoalsControllerCreateGoalRecommendationData,
  AdvisorGoalsControllerCreateGoalRecommendationResponse,
  AdvisorUsersControllerGetAccountsData,
  AdvisorUsersControllerGetAccountsResponse,
  AdvisorUsersControllerGetBudgetsData,
  AdvisorUsersControllerGetBudgetsResponse,
  AdvisorUsersControllerGetChatUsersData,
  AdvisorUsersControllerGetChatUsersResponse,
  AdvisorUsersControllerGetDonutStatsData,
  AdvisorUsersControllerGetDonutStatsResponse,
  AdvisorUsersControllerGetGoalsData,
  AdvisorUsersControllerGetGoalsResponse,
  AdvisorUsersControllerGetIncomeStatsData,
  AdvisorUsersControllerGetIncomeStatsResponse,
  AdvisorUsersControllerGetLinearStatsData,
  AdvisorUsersControllerGetLinearStatsResponse,
  AdvisorUsersControllerGetSpendingStatsData,
  AdvisorUsersControllerGetSpendingStatsResponse,
  AdvisorUsersControllerGetTransactionsData,
  AdvisorUsersControllerGetTransactionsResponse,
  AdvisorUsersControllerGetUserByIdData,
  AdvisorUsersControllerGetUserByIdResponse,
  AdvisorUsersControllerGetUserQuestionnaireData,
  AdvisorUsersControllerGetUserQuestionnaireResponse,
  AdvisorUsersControllerGetUsersResponse,
  AppointmentsControllerCreateAppointmentData,
  AppointmentsControllerCreateAppointmentResponse,
  AppointmentsControllerGetAppointmentsData,
  AppointmentsControllerGetAppointmentsResponse,
  AppointmentsControllerWebhookResponse,
  AuthControllerLoginData,
  AuthControllerLoginResponse,
  AuthControllerLogoutResponse,
  AuthControllerRegisterData,
  AuthControllerRegisterResponse,
  AuthControllerResetPasswordData,
  AuthControllerResetPasswordResponse,
  BankingControllerCreateAccountsData,
  BankingControllerCreateAccountsResponse,
  BankingControllerCreateLinkTokenData,
  BankingControllerCreateLinkTokenResponse,
  BankingControllerCreateManualAccountData,
  BankingControllerCreateManualAccountResponse,
  BankingControllerDeleteAccountData,
  BankingControllerDeleteAccountResponse,
  BankingControllerDeleteManualAccountData,
  BankingControllerDeleteManualAccountResponse,
  BankingControllerEditManualAccountData,
  BankingControllerEditManualAccountResponse,
  BankingControllerGetAccountsResponse,
  BankingControllerGetDonutStatsData,
  BankingControllerGetDonutStatsResponse,
  BankingControllerGetIncomeStatsData,
  BankingControllerGetIncomeStatsResponse,
  BankingControllerGetLinearStatsData,
  BankingControllerGetLinearStatsResponse,
  BankingControllerGetManualAccountData,
  BankingControllerGetManualAccountResponse,
  BankingControllerGetManualAccountsResponse,
  BankingControllerGetSpendingStatsData,
  BankingControllerGetSpendingStatsResponse,
  BankingControllerWebhookResponse,
  BudgetControllerAddBudgetData,
  BudgetControllerAddBudgetResponse,
  BudgetControllerDeleteBudgetData,
  BudgetControllerDeleteBudgetResponse,
  BudgetControllerGetAllBudgetsData,
  BudgetControllerGetAllBudgetsResponse,
  BudgetControllerGetBudgetData,
  BudgetControllerGetBudgetResponse,
  BudgetControllerUpdateBudgetData,
  BudgetControllerUpdateBudgetResponse,
  EmailNotificationsControllerBaselineResponse,
  EmailNotificationsControllerDispatchResponse,
  EmailNotificationsControllerEvaluateResponse,
  EmailPreviewControllerSendData,
  EmailPreviewControllerSendResponse,
  EmployerAdvisorControllerGetAllAdvisorsResponse,
  EmployerStatsControllerGetAgeStatsResponse,
  EmployerStatsControllerGetGenderStatsResponse,
  EmployerStatsControllerGetIncomeStatsResponse,
  EmployerStatsControllerGetRaceStatsResponse,
  EmployerStatsControllerGetTopicStatsResponse,
  EmployerStatsControllerGetUserStatsData,
  EmployerStatsControllerGetUserStatsResponse,
  EmployerUsersControllerChangeRoleData,
  EmployerUsersControllerChangeRoleResponse,
  EmployerUsersControllerDeleteEmployeeData,
  EmployerUsersControllerDeleteEmployeeResponse,
  EmployerUsersControllerGetAllEmployeesResponse,
  FileControllerGetPresignedUrlData,
  FileControllerGetPresignedUrlResponse,
  FileControllerGetSignedUrlData,
  FileControllerGetSignedUrlResponse,
  GoalsControllerAcceptRecommendationData,
  GoalsControllerAcceptRecommendationResponse,
  GoalsControllerAddData,
  GoalsControllerAddResponse,
  GoalsControllerAddStepData,
  GoalsControllerAddStepResponse,
  GoalsControllerArchiveData,
  GoalsControllerArchiveResponse,
  GoalsControllerClaimAmountData,
  GoalsControllerClaimAmountResponse,
  GoalsControllerCompleteData,
  GoalsControllerCompleteResponse,
  GoalsControllerDeleteData,
  GoalsControllerDeleteResponse,
  GoalsControllerDeleteStepData,
  GoalsControllerDeleteStepResponse,
  GoalsControllerGetAllData,
  GoalsControllerGetAllResponse,
  GoalsControllerGetData,
  GoalsControllerGetRecommendationsResponse,
  GoalsControllerGetResponse,
  GoalsControllerGetSavedValueData,
  GoalsControllerGetSavedValueResponse,
  GoalsControllerGetStepsData,
  GoalsControllerGetStepsResponse,
  GoalsControllerReactivateData,
  GoalsControllerReactivateResponse,
  GoalsControllerRejectRecommendationData,
  GoalsControllerRejectRecommendationResponse,
  GoalsControllerReorderStepsData,
  GoalsControllerReorderStepsResponse,
  GoalsControllerToggleStepData,
  GoalsControllerToggleStepResponse,
  GoalsControllerUpdateData,
  GoalsControllerUpdateResponse,
  GoalsControllerUpdateStepData,
  GoalsControllerUpdateStepResponse,
  InsightsControllerGetInsightsData,
  InsightsControllerGetInsightsResponse,
  MessageControllerGetAllMessagesData,
  MessageControllerGetAllMessagesResponse,
  MessageControllerMarkThreadReadData,
  MessageControllerMarkThreadReadResponse,
  NotificationControllerGetAllData,
  NotificationControllerGetAllResponse,
  NotificationControllerMarkAsReadData,
  NotificationControllerMarkAsReadResponse,
  OnboardingControllerGetAnswersResponse,
  OnboardingControllerOnboardingData,
  OnboardingControllerOnboardingResponse,
  OnboardingControllerUpdateAnswersData,
  OnboardingControllerUpdateAnswersResponse,
  QueueControllerMonthlyJobsResponse,
  QueueControllerProcessJobsResponse,
  QueueControllerSyncTransactionsResponse,
  SupportControllerCreateTicketData,
  SupportControllerCreateTicketResponse,
  SupportControllerSearchData,
  SupportControllerSearchResponse,
  TransactionControllerBulkEditTransactionsData,
  TransactionControllerBulkEditTransactionsResponse,
  TransactionControllerEditTransactionData,
  TransactionControllerEditTransactionResponse,
  TransactionControllerGetTransactionsData,
  TransactionControllerGetTransactionsResponse,
  TransactionControllerToggleExcludedData,
  TransactionControllerToggleExcludedResponse,
  UserControllerChangePasswordData,
  UserControllerChangePasswordResponse,
  UserControllerDeleteUserResponse,
  UserControllerEditProfileData,
  UserControllerEditProfileResponse,
  UserControllerGetLoggedUserResponse,
  VerifyControllerVerifyEmailData,
  VerifyControllerVerifyEmailResponse,
  VerifyControllerVerifyResetPasswordTokenData,
  VerifyControllerVerifyResetPasswordTokenResponse,
} from './types.gen'

export class UserService {
  /**
   * @returns UserData Returns the logged user
   * @throws ApiError
   */
  public static userControllerGetLoggedUser(): CancelablePromise<UserControllerGetLoggedUserResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/user',
    })
  }

  /**
   * @returns CommonResponse Returns the message that user was deleted successfully
   * @throws ApiError
   */
  public static userControllerDeleteUser(): CancelablePromise<UserControllerDeleteUserResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/user',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserData Returns the updated user
   * @throws ApiError
   */
  public static userControllerEditProfile(
    data: UserControllerEditProfileData,
  ): CancelablePromise<UserControllerEditProfileResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/user/edit',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserData Returns the updated user
   * @throws ApiError
   */
  public static userControllerChangePassword(
    data: UserControllerChangePasswordData,
  ): CancelablePromise<UserControllerChangePasswordResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/user/password',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }
}

export class MessageService {
  /**
   * @param data The data for the request.
   * @param data.recipientId
   * @param data.skip
   * @param data.take
   * @returns MessageData Get all messages
   * @throws ApiError
   */
  public static messageControllerGetAllMessages(
    data: MessageControllerGetAllMessagesData,
  ): CancelablePromise<MessageControllerGetAllMessagesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/messages/{recipientId}',
      path: {
        recipientId: data.recipientId,
      },
      query: {
        skip: data.skip,
        take: data.take,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.recipientId
   * @returns unknown Mark a conversation (messages from :recipientId) as read
   * @throws ApiError
   */
  public static messageControllerMarkThreadRead(
    data: MessageControllerMarkThreadReadData,
  ): CancelablePromise<MessageControllerMarkThreadReadResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/messages/{recipientId}/read',
      path: {
        recipientId: data.recipientId,
      },
    })
  }
}

export class QueueService {
  /**
   * @returns unknown
   * @throws ApiError
   */
  public static queueControllerProcessJobs(): CancelablePromise<QueueControllerProcessJobsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/queue/process-jobs',
    })
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static queueControllerSyncTransactions(): CancelablePromise<QueueControllerSyncTransactionsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/queue/sync-transactions',
    })
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static queueControllerMonthlyJobs(): CancelablePromise<QueueControllerMonthlyJobsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/queue/monthly-jobs',
    })
  }
}

export class TransactionService {
  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @param data.type
   * @returns MappedTransaction Transactions fetched successfully
   * @throws ApiError
   */
  public static transactionControllerGetTransactions(
    data: TransactionControllerGetTransactionsData,
  ): CancelablePromise<TransactionControllerGetTransactionsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/transactions',
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        type: data.type,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns MappedTransaction Transactions edited successfully
   * @throws ApiError
   */
  public static transactionControllerBulkEditTransactions(
    data: TransactionControllerBulkEditTransactionsData,
  ): CancelablePromise<TransactionControllerBulkEditTransactionsResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/transactions',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.transactionId
   * @returns MappedTransaction Transaction excluded status toggled successfully
   * @throws ApiError
   */
  public static transactionControllerToggleExcluded(
    data: TransactionControllerToggleExcludedData,
  ): CancelablePromise<TransactionControllerToggleExcludedResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/transaction/{transactionId}/toggle-excluded',
      path: {
        transactionId: data.transactionId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.transactionId
   * @param data.requestBody
   * @returns EditedTransaction Transaction edited successfully
   * @throws ApiError
   */
  public static transactionControllerEditTransaction(
    data: TransactionControllerEditTransactionData,
  ): CancelablePromise<TransactionControllerEditTransactionResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/transaction/{transactionId}',
      path: {
        transactionId: data.transactionId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }
}

export class BankingService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns LinkTokenData Link token created successfully
   * @throws ApiError
   */
  public static bankingControllerCreateLinkToken(
    data: BankingControllerCreateLinkTokenData,
  ): CancelablePromise<BankingControllerCreateLinkTokenResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/banking/auth',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CreateAccountsData Bank accounts created successfully
   * @throws ApiError
   */
  public static bankingControllerCreateAccounts(
    data: BankingControllerCreateAccountsData,
  ): CancelablePromise<BankingControllerCreateAccountsResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/banking/account',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns ManualAccountData Manual account created successfully
   * @throws ApiError
   */
  public static bankingControllerCreateManualAccount(
    data: BankingControllerCreateManualAccountData,
  ): CancelablePromise<BankingControllerCreateManualAccountResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/banking/account/custom',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.accountId
   * @param data.requestBody
   * @returns ManualAccountData Manual account edited successfully
   * @throws ApiError
   */
  public static bankingControllerEditManualAccount(
    data: BankingControllerEditManualAccountData,
  ): CancelablePromise<BankingControllerEditManualAccountResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/banking/account/custom/{accountId}',
      path: {
        accountId: data.accountId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.accountId
   * @returns ManualAccountData Manual account deleted successfully
   * @throws ApiError
   */
  public static bankingControllerDeleteManualAccount(
    data: BankingControllerDeleteManualAccountData,
  ): CancelablePromise<BankingControllerDeleteManualAccountResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/banking/account/custom/{accountId}',
      path: {
        accountId: data.accountId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.accountId
   * @returns ManualAccountData Manual account retrieved successfully
   * @throws ApiError
   */
  public static bankingControllerGetManualAccount(
    data: BankingControllerGetManualAccountData,
  ): CancelablePromise<BankingControllerGetManualAccountResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/banking/account/custom/{accountId}',
      path: {
        accountId: data.accountId,
      },
    })
  }

  /**
   * @returns GetAccounts Bank accounts retrieved successfully
   * @throws ApiError
   */
  public static bankingControllerGetAccounts(): CancelablePromise<BankingControllerGetAccountsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/banking/accounts',
    })
  }

  /**
   * @returns ManualAccountData Manual accounts retrieved successfully
   * @throws ApiError
   */
  public static bankingControllerGetManualAccounts(): CancelablePromise<BankingControllerGetManualAccountsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/banking/accounts/custom',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.accountId
   * @returns AccountData Bank account deleted successfully
   * @throws ApiError
   */
  public static bankingControllerDeleteAccount(
    data: BankingControllerDeleteAccountData,
  ): CancelablePromise<BankingControllerDeleteAccountResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/banking/account/{accountId}',
      path: {
        accountId: data.accountId,
      },
    })
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static bankingControllerWebhook(): CancelablePromise<BankingControllerWebhookResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/banking/webhook',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.period
   * @param data.type
   * @returns GetLinearStatsData Linear stats retrieved successfully
   * @throws ApiError
   */
  public static bankingControllerGetLinearStats(
    data: BankingControllerGetLinearStatsData,
  ): CancelablePromise<BankingControllerGetLinearStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/banking/stats/linear',
      query: {
        period: data.period,
        type: data.type,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.type
   * @returns GetDonutStatsData Donut stats retrieved successfully
   * @throws ApiError
   */
  public static bankingControllerGetDonutStats(
    data: BankingControllerGetDonutStatsData,
  ): CancelablePromise<BankingControllerGetDonutStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/banking/stats/donut',
      query: {
        type: data.type,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @returns GetIncomeStatsData Income stats retrieved successfully
   * @throws ApiError
   */
  public static bankingControllerGetIncomeStats(
    data: BankingControllerGetIncomeStatsData,
  ): CancelablePromise<BankingControllerGetIncomeStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/banking/stats/income',
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @returns GetSpendingStatsData Spending stats retrieved successfully
   * @throws ApiError
   */
  public static bankingControllerGetSpendingStats(
    data: BankingControllerGetSpendingStatsData,
  ): CancelablePromise<BankingControllerGetSpendingStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/banking/stats/spending',
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
      },
    })
  }
}

export class GoalsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns GoalData Goal created successfully
   * @throws ApiError
   */
  public static goalsControllerAdd(
    data: GoalsControllerAddData,
  ): CancelablePromise<GoalsControllerAddResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/goal',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @param data.requestBody
   * @returns GoalData Goal updated successfully
   * @throws ApiError
   */
  public static goalsControllerUpdate(
    data: GoalsControllerUpdateData,
  ): CancelablePromise<GoalsControllerUpdateResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/goal/{goalId}',
      path: {
        goalId: data.goalId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @returns void Goal deleted successfully
   * @throws ApiError
   */
  public static goalsControllerDelete(
    data: GoalsControllerDeleteData,
  ): CancelablePromise<GoalsControllerDeleteResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/goal/{goalId}',
      path: {
        goalId: data.goalId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @returns GoalData Goal retrieved successfully
   * @throws ApiError
   */
  public static goalsControllerGet(
    data: GoalsControllerGetData,
  ): CancelablePromise<GoalsControllerGetResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/goal/{goalId}',
      path: {
        goalId: data.goalId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.orderBy
   * @param data.status
   * @returns GoalData Goals retrieved successfully
   * @throws ApiError
   */
  public static goalsControllerGetAll(
    data: GoalsControllerGetAllData,
  ): CancelablePromise<GoalsControllerGetAllResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/goals',
      query: {
        orderBy: data.orderBy,
        status: data.status,
      },
    })
  }

  /**
   * @returns GoalRecommendationData Recommendations retrieved successfully
   * @throws ApiError
   */
  public static goalsControllerGetRecommendations(): CancelablePromise<GoalsControllerGetRecommendationsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/goals/recommendations',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.recommendationId
   * @returns GoalData Recommendation added successfully
   * @throws ApiError
   */
  public static goalsControllerAcceptRecommendation(
    data: GoalsControllerAcceptRecommendationData,
  ): CancelablePromise<GoalsControllerAcceptRecommendationResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/goals/recommendation/{recommendationId}',
      path: {
        recommendationId: data.recommendationId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.recommendationId
   * @returns void Recommendation rejected successfully
   * @throws ApiError
   */
  public static goalsControllerRejectRecommendation(
    data: GoalsControllerRejectRecommendationData,
  ): CancelablePromise<GoalsControllerRejectRecommendationResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/goals/recommendation/{recommendationId}',
      path: {
        recommendationId: data.recommendationId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @param data.requestBody
   * @returns GoalData Goal claimed successfully
   * @throws ApiError
   */
  public static goalsControllerClaimAmount(
    data: GoalsControllerClaimAmountData,
  ): CancelablePromise<GoalsControllerClaimAmountResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/goal/{goalId}/claim',
      path: {
        goalId: data.goalId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @returns GoalsSavedValue Saved value retrieved successfully
   * @throws ApiError
   */
  public static goalsControllerGetSavedValue(
    data: GoalsControllerGetSavedValueData,
  ): CancelablePromise<GoalsControllerGetSavedValueResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/goals/saved',
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @returns GoalData Goal completed successfully
   * @throws ApiError
   */
  public static goalsControllerComplete(
    data: GoalsControllerCompleteData,
  ): CancelablePromise<GoalsControllerCompleteResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/goal/{goalId}/complete',
      path: {
        goalId: data.goalId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @returns GoalData Goal archived successfully
   * @throws ApiError
   */
  public static goalsControllerArchive(
    data: GoalsControllerArchiveData,
  ): CancelablePromise<GoalsControllerArchiveResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/goal/{goalId}/archive',
      path: {
        goalId: data.goalId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @returns GoalData Goal reactivated successfully
   * @throws ApiError
   */
  public static goalsControllerReactivate(
    data: GoalsControllerReactivateData,
  ): CancelablePromise<GoalsControllerReactivateResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/goal/{goalId}/reactivate',
      path: {
        goalId: data.goalId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @returns GoalStepData Steps retrieved successfully
   * @throws ApiError
   */
  public static goalsControllerGetSteps(
    data: GoalsControllerGetStepsData,
  ): CancelablePromise<GoalsControllerGetStepsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/goal/{goalId}/steps',
      path: {
        goalId: data.goalId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @param data.requestBody
   * @returns GoalStepData Step created successfully
   * @throws ApiError
   */
  public static goalsControllerAddStep(
    data: GoalsControllerAddStepData,
  ): CancelablePromise<GoalsControllerAddStepResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/goal/{goalId}/steps',
      path: {
        goalId: data.goalId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @param data.stepId
   * @param data.requestBody
   * @returns GoalStepData Step updated successfully
   * @throws ApiError
   */
  public static goalsControllerUpdateStep(
    data: GoalsControllerUpdateStepData,
  ): CancelablePromise<GoalsControllerUpdateStepResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/goal/{goalId}/step/{stepId}',
      path: {
        goalId: data.goalId,
        stepId: data.stepId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @param data.stepId
   * @returns void Step deleted successfully
   * @throws ApiError
   */
  public static goalsControllerDeleteStep(
    data: GoalsControllerDeleteStepData,
  ): CancelablePromise<GoalsControllerDeleteStepResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/goal/{goalId}/step/{stepId}',
      path: {
        goalId: data.goalId,
        stepId: data.stepId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @param data.stepId
   * @returns GoalStepData Step toggled successfully
   * @throws ApiError
   */
  public static goalsControllerToggleStep(
    data: GoalsControllerToggleStepData,
  ): CancelablePromise<GoalsControllerToggleStepResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/goal/{goalId}/step/{stepId}/toggle',
      path: {
        goalId: data.goalId,
        stepId: data.stepId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.goalId
   * @param data.requestBody
   * @returns void Steps reordered successfully
   * @throws ApiError
   */
  public static goalsControllerReorderSteps(
    data: GoalsControllerReorderStepsData,
  ): CancelablePromise<GoalsControllerReorderStepsResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/goal/{goalId}/steps/reorder',
      path: {
        goalId: data.goalId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }
}

export class NotificationsService {
  /**
   * @param data The data for the request.
   * @param data.status
   * @param data.action
   * @returns NotificationData Get all notifications
   * @throws ApiError
   */
  public static notificationControllerGetAll(
    data: NotificationControllerGetAllData = {},
  ): CancelablePromise<NotificationControllerGetAllResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/notifications',
      query: {
        status: data.status,
        action: data.action,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.notificationId
   * @returns NotificationData Marked notification as read
   * @throws ApiError
   */
  public static notificationControllerMarkAsRead(
    data: NotificationControllerMarkAsReadData,
  ): CancelablePromise<NotificationControllerMarkAsReadResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/notification/read/{notificationId}',
      path: {
        notificationId: data.notificationId,
      },
    })
  }
}

export class FileService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns GetSignedURLResponse Returns a presigned URL for uploading a file
   * @throws ApiError
   */
  public static fileControllerGetPresignedUrl(
    data: FileControllerGetPresignedUrlData,
  ): CancelablePromise<FileControllerGetPresignedUrlResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/file/presigned-url',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.filename
   * @returns string Returns a signed URL for downloading a file
   * @throws ApiError
   */
  public static fileControllerGetSignedUrl(
    data: FileControllerGetSignedUrlData,
  ): CancelablePromise<FileControllerGetSignedUrlResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/file',
      query: {
        filename: data.filename,
      },
    })
  }
}

export class BudgetService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns BudgetData Budget created successfully
   * @throws ApiError
   */
  public static budgetControllerAddBudget(
    data: BudgetControllerAddBudgetData,
  ): CancelablePromise<BudgetControllerAddBudgetResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/budget',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.budgetId
   * @param data.requestBody
   * @returns BudgetData Budget updated successfully
   * @throws ApiError
   */
  public static budgetControllerUpdateBudget(
    data: BudgetControllerUpdateBudgetData,
  ): CancelablePromise<BudgetControllerUpdateBudgetResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/budget/{budgetId}',
      path: {
        budgetId: data.budgetId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.budgetId
   * @returns void Budget deleted successfully
   * @throws ApiError
   */
  public static budgetControllerDeleteBudget(
    data: BudgetControllerDeleteBudgetData,
  ): CancelablePromise<BudgetControllerDeleteBudgetResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/budget/{budgetId}',
      path: {
        budgetId: data.budgetId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.budgetId
   * @returns BudgetData Budget fetched successfully
   * @throws ApiError
   */
  public static budgetControllerGetBudget(
    data: BudgetControllerGetBudgetData,
  ): CancelablePromise<BudgetControllerGetBudgetResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/budget/{budgetId}',
      path: {
        budgetId: data.budgetId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @returns BudgetStats Budgets fetched successfully
   * @throws ApiError
   */
  public static budgetControllerGetAllBudgets(
    data: BudgetControllerGetAllBudgetsData,
  ): CancelablePromise<BudgetControllerGetAllBudgetsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/budgets',
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
      },
    })
  }
}

export class RolanWealthService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserData Returned created user object
   * @throws ApiError
   */
  public static authControllerRegister(
    data: AuthControllerRegisterData,
  ): CancelablePromise<AuthControllerRegisterResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/register',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserData Returned logged in user object
   * @throws ApiError
   */
  public static authControllerLogin(
    data: AuthControllerLoginData,
  ): CancelablePromise<AuthControllerLoginResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/login',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @returns CommonResponse Returned when user is logged out
   * @throws ApiError
   */
  public static authControllerLogout(): CancelablePromise<AuthControllerLogoutResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/logout',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CommonResponse Returned when password reset email is sent. Notice! This response is always successful, even if email does not exist in the database.
   * @throws ApiError
   */
  public static authControllerResetPassword(
    data: AuthControllerResetPasswordData,
  ): CancelablePromise<AuthControllerResetPasswordResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/reset-password',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CommonResponse Returned when email is verified successfully
   * @throws ApiError
   */
  public static verifyControllerVerifyEmail(
    data: VerifyControllerVerifyEmailData,
  ): CancelablePromise<VerifyControllerVerifyEmailResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/verify/email',
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Returned when validation fails',
        404: 'Returned when email verification token is invalid',
        500: 'Returned when something went wrong',
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CommonResponse Returned when password is changed successfully
   * @throws ApiError
   */
  public static verifyControllerVerifyResetPasswordToken(
    data: VerifyControllerVerifyResetPasswordTokenData,
  ): CancelablePromise<VerifyControllerVerifyResetPasswordTokenResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/verify/reset-password',
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        400: 'Returned when validation fails',
        404: 'Returned when reset password token is invalid',
        500: 'Returned when something went wrong',
      },
    })
  }
}

export class OnboardingService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserData Onboarding answers created successfully
   * @throws ApiError
   */
  public static onboardingControllerOnboarding(
    data: OnboardingControllerOnboardingData,
  ): CancelablePromise<OnboardingControllerOnboardingResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/onboarding',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @returns OnboardingAnswers Onboarding answers fetched successfully
   * @throws ApiError
   */
  public static onboardingControllerGetAnswers(): CancelablePromise<OnboardingControllerGetAnswersResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/onboarding',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserData Onboarding answers updated successfully
   * @throws ApiError
   */
  public static onboardingControllerUpdateAnswers(
    data: OnboardingControllerUpdateAnswersData,
  ): CancelablePromise<OnboardingControllerUpdateAnswersResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/onboarding',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }
}

export class AdvisorService {
  /**
   * @param data The data for the request.
   * @param data.query
   * @returns AdvisorData Get all advisors
   * @throws ApiError
   */
  public static advisorControllerGetAllAdvisors(
    data: AdvisorControllerGetAllAdvisorsData = {},
  ): CancelablePromise<AdvisorControllerGetAllAdvisorsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors',
      query: {
        query: data.query,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserData Grant access to advisor
   * @throws ApiError
   */
  public static advisorControllerGrantAccess(
    data: AdvisorControllerGrantAccessData,
  ): CancelablePromise<AdvisorControllerGrantAccessResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/advisor/grant-access',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns UserData Revoke access to advisor
   * @throws ApiError
   */
  public static advisorControllerRevokeAccess(
    data: AdvisorControllerRevokeAccessData,
  ): CancelablePromise<AdvisorControllerRevokeAccessResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/advisor/revoke-access',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }
}

export class AdvisorsService {
  /**
   * @returns UserData Get users who grant access to the advisor
   * @throws ApiError
   */
  public static advisorUsersControllerGetUsers(): CancelablePromise<AdvisorUsersControllerGetUsersResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/users',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns UserData Get user by id
   * @throws ApiError
   */
  public static advisorUsersControllerGetUserById(
    data: AdvisorUsersControllerGetUserByIdData,
  ): CancelablePromise<AdvisorUsersControllerGetUserByIdResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}',
      path: {
        userId: data.userId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.query
   * @returns UserData Get users who already talked to the advisor
   * @throws ApiError
   */
  public static advisorUsersControllerGetChatUsers(
    data: AdvisorUsersControllerGetChatUsersData = {},
  ): CancelablePromise<AdvisorUsersControllerGetChatUsersResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/users/chat',
      query: {
        query: data.query,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns FinancialAnswer Get user questionnaire
   * @throws ApiError
   */
  public static advisorUsersControllerGetUserQuestionnaire(
    data: AdvisorUsersControllerGetUserQuestionnaireData,
  ): CancelablePromise<AdvisorUsersControllerGetUserQuestionnaireResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}/questionnaire',
      path: {
        userId: data.userId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.type
   * @returns GetDonutStatsData Donut stats retrieved successfully
   * @throws ApiError
   */
  public static advisorUsersControllerGetDonutStats(
    data: AdvisorUsersControllerGetDonutStatsData,
  ): CancelablePromise<AdvisorUsersControllerGetDonutStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}/donut-stats',
      path: {
        userId: data.userId,
      },
      query: {
        type: data.type,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.startDate
   * @param data.endDate
   * @returns GetIncomeStatsData Income stats retrieved successfully
   * @throws ApiError
   */
  public static advisorUsersControllerGetIncomeStats(
    data: AdvisorUsersControllerGetIncomeStatsData,
  ): CancelablePromise<AdvisorUsersControllerGetIncomeStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}/income-stats',
      path: {
        userId: data.userId,
      },
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.startDate
   * @param data.endDate
   * @returns GetSpendingStatsData Spending stats retrieved successfully
   * @throws ApiError
   */
  public static advisorUsersControllerGetSpendingStats(
    data: AdvisorUsersControllerGetSpendingStatsData,
  ): CancelablePromise<AdvisorUsersControllerGetSpendingStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}/spending-stats',
      path: {
        userId: data.userId,
      },
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.period
   * @param data.type
   * @returns GetLinearStatsData Linear stats retrieved successfully
   * @throws ApiError
   */
  public static advisorUsersControllerGetLinearStats(
    data: AdvisorUsersControllerGetLinearStatsData,
  ): CancelablePromise<AdvisorUsersControllerGetLinearStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}/linear-stats',
      path: {
        userId: data.userId,
      },
      query: {
        period: data.period,
        type: data.type,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.startDate
   * @param data.endDate
   * @returns BudgetStats Budgets fetched successfully
   * @throws ApiError
   */
  public static advisorUsersControllerGetBudgets(
    data: AdvisorUsersControllerGetBudgetsData,
  ): CancelablePromise<AdvisorUsersControllerGetBudgetsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}/budgets',
      path: {
        userId: data.userId,
      },
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns GoalData Goals retrieved successfully
   * @throws ApiError
   */
  public static advisorUsersControllerGetGoals(
    data: AdvisorUsersControllerGetGoalsData,
  ): CancelablePromise<AdvisorUsersControllerGetGoalsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}/goals',
      path: {
        userId: data.userId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns GetAccounts Accounts retrieved successfully
   * @throws ApiError
   */
  public static advisorUsersControllerGetAccounts(
    data: AdvisorUsersControllerGetAccountsData,
  ): CancelablePromise<AdvisorUsersControllerGetAccountsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}/accounts',
      path: {
        userId: data.userId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.startDate
   * @param data.endDate
   * @param data.type
   * @returns MappedTransaction Transactions retrieved successfully
   * @throws ApiError
   */
  public static advisorUsersControllerGetTransactions(
    data: AdvisorUsersControllerGetTransactionsData,
  ): CancelablePromise<AdvisorUsersControllerGetTransactionsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/user/{userId}/transactions',
      path: {
        userId: data.userId,
      },
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        type: data.type,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.requestBody
   * @returns GoalRecommendationData Create a goal recommendation for a user
   * @throws ApiError
   */
  public static advisorGoalsControllerCreateGoalRecommendation(
    data: AdvisorGoalsControllerCreateGoalRecommendationData,
  ): CancelablePromise<AdvisorGoalsControllerCreateGoalRecommendationResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/advisors/user/{userId}/goal',
      path: {
        userId: data.userId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }
}

export class AdvisorsAppointmentsService {
  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.sort
   * @param data.limit
   * @returns AdvisorAppointmentData Get all appointments for the advisor
   * @throws ApiError
   */
  public static advisorAppointmentsControllerGetAllAppointments(
    data: AdvisorAppointmentsControllerGetAllAppointmentsData = {},
  ): CancelablePromise<AdvisorAppointmentsControllerGetAllAppointmentsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/advisors/appointments',
      query: {
        userId: data.userId,
        sort: data.sort,
        limit: data.limit,
      },
    })
  }
}

export class AdminStatsService {
  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @param data.company
   * @returns UserStatsCounter Get user stats
   * @throws ApiError
   */
  public static adminStatsControllerGetUserStats(
    data: AdminStatsControllerGetUserStatsData,
  ): CancelablePromise<AdminStatsControllerGetUserStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/stats/users',
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        company: data.company,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.company
   * @returns StatsCounter An object where each key is a gender and the value is the count of users
   * @throws ApiError
   */
  public static adminStatsControllerGetGenderStats(
    data: AdminStatsControllerGetGenderStatsData = {},
  ): CancelablePromise<AdminStatsControllerGetGenderStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/stats/gender',
      query: {
        company: data.company,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.company
   * @returns StatsCounter An object where each key is a race and the value is the count of users
   * @throws ApiError
   */
  public static adminStatsControllerGetRaceStats(
    data: AdminStatsControllerGetRaceStatsData = {},
  ): CancelablePromise<AdminStatsControllerGetRaceStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/stats/race',
      query: {
        company: data.company,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.company
   * @returns StatsCounter An object where each key is an age and the value is the count of users
   * @throws ApiError
   */
  public static adminStatsControllerGetAgeStats(
    data: AdminStatsControllerGetAgeStatsData = {},
  ): CancelablePromise<AdminStatsControllerGetAgeStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/stats/age',
      query: {
        company: data.company,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.company
   * @returns StatsCounter An object where each key is an age and the value is the count of users
   * @throws ApiError
   */
  public static adminStatsControllerGetIncomeStats(
    data: AdminStatsControllerGetIncomeStatsData = {},
  ): CancelablePromise<AdminStatsControllerGetIncomeStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/stats/income',
      query: {
        company: data.company,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.company
   * @returns StatsCounter An object where each key is a topic and the value is the count of users
   * @throws ApiError
   */
  public static adminStatsControllerGetTopicsStats(
    data: AdminStatsControllerGetTopicsStatsData = {},
  ): CancelablePromise<AdminStatsControllerGetTopicsStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/stats/topics',
      query: {
        company: data.company,
      },
    })
  }
}

export class AdminCompaniesService {
  /**
   * @returns CompanyData Get all companies
   * @throws ApiError
   */
  public static adminCompaniesControllerGetCompanies(): CancelablePromise<AdminCompaniesControllerGetCompaniesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/admin/companies',
    })
  }
}

export class AdminWhitelistService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Number of whitelisted emails added
   * @throws ApiError
   */
  public static adminWhitelistControllerAddWhitelistedEmails(
    data: AdminWhitelistControllerAddWhitelistedEmailsData,
  ): CancelablePromise<AdminWhitelistControllerAddWhitelistedEmailsResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/admin/whitelist/emails',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns unknown Number of whitelisted emails removed
   * @throws ApiError
   */
  public static adminWhitelistControllerDeleteWhitelistedEmails(
    data: AdminWhitelistControllerDeleteWhitelistedEmailsData,
  ): CancelablePromise<AdminWhitelistControllerDeleteWhitelistedEmailsResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/admin/whitelist/emails',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }
}

export class AdminUsersService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns CommonResponse Returned when user is verified successfully
   * @throws ApiError
   */
  public static adminUsersControllerVerifyUser(
    data: AdminUsersControllerVerifyUserData,
  ): CancelablePromise<AdminUsersControllerVerifyUserResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/admin/users/verify',
      body: data.requestBody,
      mediaType: 'application/json',
      errors: {
        404: 'Returned when user with given email does not exist',
      },
    })
  }
}

export class EmployerStatsService {
  /**
   * @param data The data for the request.
   * @param data.startDate
   * @param data.endDate
   * @param data.company
   * @returns UserStatsCounter Get user stats
   * @throws ApiError
   */
  public static employerStatsControllerGetUserStats(
    data: EmployerStatsControllerGetUserStatsData,
  ): CancelablePromise<EmployerStatsControllerGetUserStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/employer/stats/users',
      query: {
        startDate: data.startDate,
        endDate: data.endDate,
        company: data.company,
      },
    })
  }

  /**
   * @returns StatsCounter An object where each key is a gender and the value is the count of users
   * @throws ApiError
   */
  public static employerStatsControllerGetGenderStats(): CancelablePromise<EmployerStatsControllerGetGenderStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/employer/stats/gender',
    })
  }

  /**
   * @returns StatsCounter An object where each key is a race and the value is the count of users
   * @throws ApiError
   */
  public static employerStatsControllerGetRaceStats(): CancelablePromise<EmployerStatsControllerGetRaceStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/employer/stats/race',
    })
  }

  /**
   * @returns StatsCounter An object where each key is an age group and the value is the count of users
   * @throws ApiError
   */
  public static employerStatsControllerGetAgeStats(): CancelablePromise<EmployerStatsControllerGetAgeStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/employer/stats/age',
    })
  }

  /**
   * @returns StatsCounter An object where each key is an income group and the value is the count of users
   * @throws ApiError
   */
  public static employerStatsControllerGetIncomeStats(): CancelablePromise<EmployerStatsControllerGetIncomeStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/employer/stats/income',
    })
  }

  /**
   * @returns StatsCounter An object where each key is a topic and the value is the count of users
   * @throws ApiError
   */
  public static employerStatsControllerGetTopicStats(): CancelablePromise<EmployerStatsControllerGetTopicStatsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/employer/stats/topics',
    })
  }
}

export class EmployerUsersService {
  /**
   * @returns UserData Get all employees
   * @throws ApiError
   */
  public static employerUsersControllerGetAllEmployees(): CancelablePromise<EmployerUsersControllerGetAllEmployeesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/employer/users',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @returns void Delete employee
   * @throws ApiError
   */
  public static employerUsersControllerDeleteEmployee(
    data: EmployerUsersControllerDeleteEmployeeData,
  ): CancelablePromise<EmployerUsersControllerDeleteEmployeeResponse> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/employer/user/{userId}',
      path: {
        userId: data.userId,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.requestBody
   * @returns UserData Change company user role
   * @throws ApiError
   */
  public static employerUsersControllerChangeRole(
    data: EmployerUsersControllerChangeRoleData,
  ): CancelablePromise<EmployerUsersControllerChangeRoleResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/employer/user/{userId}/role',
      path: {
        userId: data.userId,
      },
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }
}

export class EmployerAdvisorsService {
  /**
   * @returns AdvisorData Get all advisors
   * @throws ApiError
   */
  public static employerAdvisorControllerGetAllAdvisors(): CancelablePromise<EmployerAdvisorControllerGetAllAdvisorsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/employer/advisors',
    })
  }
}

export class InsightsService {
  /**
   * @param data The data for the request.
   * @param data.page The page to load insights for
   * @returns InsightsResponse Insights for the requested page
   * @throws ApiError
   */
  public static insightsControllerGetInsights(
    data: InsightsControllerGetInsightsData,
  ): CancelablePromise<InsightsControllerGetInsightsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/insights',
      query: {
        page: data.page,
      },
    })
  }
}

export class AppointmentsService {
  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns AppointmentData The appointment has been successfully created.
   * @throws ApiError
   */
  public static appointmentsControllerCreateAppointment(
    data: AppointmentsControllerCreateAppointmentData,
  ): CancelablePromise<AppointmentsControllerCreateAppointmentResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/appointment',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }

  /**
   * @param data The data for the request.
   * @param data.userId
   * @param data.sort
   * @param data.limit
   * @returns unknown
   * @throws ApiError
   */
  public static appointmentsControllerGetAppointments(
    data: AppointmentsControllerGetAppointmentsData = {},
  ): CancelablePromise<AppointmentsControllerGetAppointmentsResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/appointments',
      query: {
        userId: data.userId,
        sort: data.sort,
        limit: data.limit,
      },
    })
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static appointmentsControllerWebhook(): CancelablePromise<AppointmentsControllerWebhookResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/appointment/webhook/receive',
    })
  }
}

export class SupportService {
  /**
   * @param data The data for the request.
   * @param data.query
   * @param data.type
   * @returns SupportSearchResponse Search results returned successfully
   * @throws ApiError
   */
  public static supportControllerSearch(
    data: SupportControllerSearchData = {},
  ): CancelablePromise<SupportControllerSearchResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/support/search',
      query: {
        query: data.query,
        type: data.type,
      },
    })
  }

  /**
   * @param data The data for the request.
   * @param data.requestBody
   * @returns void Support ticket sent successfully
   * @throws ApiError
   */
  public static supportControllerCreateTicket(
    data: SupportControllerCreateTicketData,
  ): CancelablePromise<SupportControllerCreateTicketResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/support',
      body: data.requestBody,
      mediaType: 'application/json',
    })
  }
}

export class EmailNotificationsService {
  /**
   * @returns unknown
   * @throws ApiError
   */
  public static emailNotificationsControllerEvaluate(): CancelablePromise<EmailNotificationsControllerEvaluateResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/email-notifications/evaluate',
    })
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static emailNotificationsControllerDispatch(): CancelablePromise<EmailNotificationsControllerDispatchResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/email-notifications/dispatch',
    })
  }

  /**
   * @returns unknown
   * @throws ApiError
   */
  public static emailNotificationsControllerBaseline(): CancelablePromise<EmailNotificationsControllerBaselineResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/email-notifications/baseline',
    })
  }
}

export class EmailPreviewService {
  /**
   * @param data The data for the request.
   * @param data.key Send a single template (e.g. notif.goalCheckIn). Omit to send all.
   * @returns unknown
   * @throws ApiError
   */
  public static emailPreviewControllerSend(
    data: EmailPreviewControllerSendData = {},
  ): CancelablePromise<EmailPreviewControllerSendResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/email-preview/send',
      query: {
        key: data.key,
      },
    })
  }
}
